// file: src/components/routing/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

function hasAny(...keys) {
  try {
    return keys.some(
      (k) => localStorage.getItem(k) || sessionStorage.getItem(k)
    );
  } catch {
    return false;
  }
}

/**
 * Optional prop `group`: "towing" | "landlord" | "admin"
 * If not provided, it is inferred from the current path.
 */
export default function ProtectedRoute({ children, redirectTo, group }) {
  const location = useLocation();

  const inferredGroup =
    group ||
    (location.pathname.startsWith("/towing")
      ? "towing"
      : location.pathname.startsWith("/landlord")
      ? "landlord"
      : "admin");

  // Decide which storage keys constitute "authenticated" for that group.
  let authed = false;
  let fallbackLogin = "/admin/login";

  if (inferredGroup === "towing") {
    // Cookie session; we store only a UI snapshot
    authed = hasAny("auth_user"); // ✅ new cookie-based auth indicator
    fallbackLogin = "/towing/login";
  } else if (inferredGroup === "landlord") {
    // Cookie session; we store only a UI snapshot
    authed = hasAny("landlord_user"); // ✅ new cookie-based auth indicator
    fallbackLogin = "/landlord/signin";
  } else {
    // Admin (legacy token flow)
    authed = hasAny("access_token"); // or your admin keys
    fallbackLogin = "/admin/login";
  }

  if (!authed) {
    return (
      <Navigate
        to={redirectTo || fallbackLogin}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
}
